<script setup>
import { ref, watch } from "vue";
import Form from "./Form.vue";
import { useMutation, useQueryClient } from "@tanstack/vue-query";
import apiCall from "@/utils/api";
import {
  useFetchResourceUsingId,
  useGetTranslation,
  useRoute,
  useRouter,
  useStore,
} from "@/components/Utils/functions";
import FormContainer from "./FormContainer.vue";

const router = useRouter();
const store = useStore();
const queryClient = useQueryClient();
const t = useGetTranslation();
const route = useRoute();

const userId = route?.params?.id;
const {
  isLoading,
  isFetching,
  data: user,
} = useFetchResourceUsingId("user", userId);

const userModel = ref({ ...user.value });
watch(user, (val) => {
  userModel.value = { ...val };
});

const editForm = ref();

const updateUserMtn = useMutation({
  mutationFn: async () => {
    await apiCall({
      url: `/api/user/${user.value?.id}`,
      method: "PUT",
      data: userModel.value,
    });
  },
});

const onEditFormSubmitted = async () => {
  const formInvalid = !editForm.value.validate();
  if (formInvalid) {
    return;
  }
  await updateUserMtn.mutateAsync();
  queryClient.invalidateQueries({
    queryKey: ["listUsers"],
  });
  store.commit("openSnackbar", {
    open: true,
    text: t("userEditedMsg"),
    color: "success",
  });
  router.back();
};
</script>

<template>
  <FormContainer :title="$t('userDetailsMsg')">
    <v-form ref="editForm" @submit.prevent="onEditFormSubmitted">
      <Form
        :fetchingData="isFetching"
        :performingCrud="updateUserMtn.isLoading.value"
        :model="userModel"
        :title="$t('editUserMessage')"
      />
    </v-form>
  </FormContainer>
</template>
